export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    fixed: 'left',
    slots: { default: 'opt' },
  },
  {
    field: 'syncType',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: '同步数据记录类型',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'syncTypeDesc',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: '记录类型描述',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'isvalid',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '数据是否有效',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'isvalid' },
  },
  {
    field: 'syncStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '数据同步接收状态',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'syncStatus' },
  },
  {
    field: 'syncTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    title: '同步时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'syncReplyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    title: '远端处理返回时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'resultPushStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '结果推送状态',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'resultPushStatus' },
  },
  {
    field: 'resultPushTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    title: '结果推送时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'resultPushReplyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    title: '结果推送响应时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
